import { SDate } from '@summit/core';

import { EboObjectTimePeriod } from '../base-classes/ebo-object-time-period';
import { LinehaulRun } from '../route/linehaul-run';
import { TruckAlias } from './truck-alias';

export class TruckAliasLinehaulRunAssignment extends EboObjectTimePeriod {
  truckAliasID: string;
  truckAlias: TruckAlias;
  linehaulRunID: string;
  linehaulRun: LinehaulRun;

  constructor(jsonData?: Partial<TruckAliasLinehaulRunAssignment>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.truckAlias) {
        this.truckAlias = new TruckAlias(jsonData.truckAlias);
      }
      if (jsonData.linehaulRun) {
        this.linehaulRun = new LinehaulRun(jsonData.linehaulRun);
      }
      if (jsonData.startTime) {
        this.startTime = SDate.newUtc(jsonData.startTime);
      }
      if (jsonData.endTime) {
        this.endTime = SDate.newUtc(jsonData.endTime);
      }
    }
    this.startTime ??= SDate.getNormalized();
  }

  toShortString(format?: string): string {
    if (format == 'forTruckAlias') {
      return `${this.linehaulRun ? this.linehaulRun.toShortString() : 'Unknown'}`;
    }
    if (format == 'TruckAliasOnly') {
      return `${this.truckAlias ? this.truckAlias.toShortString() : 'Unknown'} [${
        this.endTime ? this.endTime.format('M/D/YY') : 'Current'
      }]`;
    }
    return `${this.truckAlias ? this.truckAlias.toShortString() : 'Unknown'}-${
      this.linehaulRun ? this.linehaulRun.toShortString() : 'Unknown'
    }`;
  }

  toTimeLineView(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}: ${
      this.truckAlias ? this.truckAlias.toShortString() : 'Unknown'
    }`;
  }
}
